import { GetDiscount } from '../contracts';
import axios from 'axios';
import { createAxiosConfig } from '../createAxiosConfig';
import CookieHelper from '../../utils/cookieHelper';
import StatusCode from 'status-code-enum';
import { ErrorType, IGetDiscountRequest } from '../../shared/types';
import LogCannon from '@ace-clublabs/log-cannon';

export const GetDiscountApi =
  (endpoint: string): GetDiscount =>
  async (request: IGetDiscountRequest = {}) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');

      LogCannon.blast('GetDiscountApi start');
      const { data } = await axios.post(endpoint, request, createAxiosConfig(scenario, endpoint));
      LogCannon.blast('GetDiscountApi success');
      return Promise.resolve({ discount: data.discount });
    } catch (error: any) {
      LogCannon.error('GetDiscountApi error', { error: error?.message });
      if (error.response) {
        const statusCode = error.response.status;
        const errorMessage = error.response.data?.message || error?.message || error.response.data.error.message;
        if (statusCode === StatusCode.ClientErrorUnauthorized) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.SESSION_TIMEOUT,
          });
        }

        if (statusCode === StatusCode.ClientErrorForbidden) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.AUTH_ERROR,
          });
        }

        return Promise.reject({
          message: errorMessage,
          type: ErrorType.SYSTEM_ERROR,
        });
      }
      return Promise.reject({
        message: error,
      });
    }
  };
